
/**
 * A function that returns the URL part common to the endpoints.
 */
export const root = () => {
    let __root = "";
    
    if (process.env.RUNTIME_ENV === "local") {       
        __root = "https://api-forms.dev.m2msystems.cloud";
    }

    if (process.env.RUNTIME_ENV === "localDev") {       
        __root = "";
    }

    if (process.env.RUNTIME_ENV === "development") {       
        __root = "https://api-forms.dev.m2msystems.cloud";
    }

    if (process.env.RUNTIME_ENV === "production") {       
        __root = "https://api-forms.m2msystems.cloud";
    }
    return __root
}

/**
 * health check
 * 
 */
export const healthCheck = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/health_check`;
    return __queries ? `${__path}?${__queries}` : __path;
};
healthCheck.method = "GET" as const;
healthCheck.authSchema = {"type":"","header":""} as const;

/**
 * DraftRevisionのフォーム情報を取得する
 * 
 */
export const formGet = ({id}: {id: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formGet.method = "GET" as const;
formGet.authSchema = {"type":"","header":""} as const;

/**
 * 特定のRevisionのフォーム情報を取得する
 * 
 */
export const formGetByRevision = ({id, revision}: {id: string, revision: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}/${revision}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formGetByRevision.method = "GET" as const;
formGetByRevision.authSchema = {"type":"","header":""} as const;

/**
 * Formを新規作成する
 * 
 */
export const formCreate = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formCreate.method = "POST" as const;
formCreate.authSchema = {"type":"","header":""} as const;

/**
 * ユーザーに紐づいたフォームを全件取得する
 * 
 */
export const formFindAll = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formFindAll.method = "GET" as const;
formFindAll.authSchema = {"type":"","header":""} as const;

/**
 * Formを更新する
 * 
 */
export const formUpdate = ({id}: {id: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formUpdate.method = "PATCH" as const;
formUpdate.authSchema = {"type":"","header":""} as const;

/**
 * 他のユーザーが共有したフォームを全件取得する
 * 
 */
export const sharedFormFindAll = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/shared-forms`;
    return __queries ? `${__path}?${__queries}` : __path;
};
sharedFormFindAll.method = "GET" as const;
sharedFormFindAll.authSchema = {"type":"","header":""} as const;

/**
 * Formのシート機能を有効化する
 * 
 */
export const formActivateSheetFeature = ({id}: {id: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}/sheets/activate`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formActivateSheetFeature.method = "PATCH" as const;
formActivateSheetFeature.authSchema = {"type":"","header":""} as const;

/**
 * フォームに紐づいたConnectedSheetを取得する
 * 
 */
export const formGetConnectedSheet = ({id}: {id: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}/connected-sheet`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formGetConnectedSheet.method = "GET" as const;
formGetConnectedSheet.authSchema = {"type":"","header":""} as const;

/**
 * Formの公開ステータスをPrivateに変更する
 * 
 */
export const formPublishStatusChangeToPrivate = ({id}: {id: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}/private`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formPublishStatusChangeToPrivate.method = "PATCH" as const;
formPublishStatusChangeToPrivate.authSchema = {"type":"","header":""} as const;

/**
 * FormのContentを更新する
 * 
 */
export const formsCreateNewRevision = ({id}: {id: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formsCreateNewRevision.method = "POST" as const;
formsCreateNewRevision.authSchema = {"type":"","header":""} as const;

/**
 * Formの質問の順番を更新する
 * 
 */
export const formUpdateQuestionsOrder = ({id}: {id: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}/questions/order`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formUpdateQuestionsOrder.method = "POST" as const;
formUpdateQuestionsOrder.authSchema = {"type":"","header":""} as const;

/**
 * Form内容を確定し公開する
 * 
 */
export const formPublish = ({id}: {id: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}/publish`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formPublish.method = "POST" as const;
formPublish.authSchema = {"type":"","header":""} as const;

/**
 * フォームのオーナーを指定されたユーザーに差し替える
 * 
 */
export const formReplaceOwner = ({id}: {id: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}/replace-owner`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formReplaceOwner.method = "POST" as const;
formReplaceOwner.authSchema = {"type":"","header":""} as const;

/**
 * 同じmatsuriドメインのユーザー間でフォームのオーナーを差し替える
 * 
 */
export const formForceReplaceOwner = ({id}: {id: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}/force-replace-owner`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formForceReplaceOwner.method = "POST" as const;
formForceReplaceOwner.authSchema = {"type":"","header":""} as const;

/**
 * 質問を作成する
 * 
 */
export const formQuestionCreate = ({formId}: {formId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/questions/append`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formQuestionCreate.method = "POST" as const;
formQuestionCreate.authSchema = {"type":"","header":""} as const;

/**
 * 質問を挿入する
 * 
 */
export const formQuestionInsert = ({formId}: {formId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/questions/insert`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formQuestionInsert.method = "POST" as const;
formQuestionInsert.authSchema = {"type":"","header":""} as const;

/**
 * 質問を削除する
 * 
 */
export const formQuestionDelete = ({formId}: {formId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/questions/delete`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formQuestionDelete.method = "POST" as const;
formQuestionDelete.authSchema = {"type":"","header":""} as const;

/**
 * 質問を更新する
 * 
 */
export const formQuestionUpdate = ({formId, questionId}: {formId: string, questionId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/questions/${questionId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formQuestionUpdate.method = "PATCH" as const;
formQuestionUpdate.authSchema = {"type":"","header":""} as const;

/**
 * フォームの質問をJSON形式でエクスポートする
 * 
 */
export const formQuestionsExport = ({formId}: {formId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/questions/export`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formQuestionsExport.method = "GET" as const;
formQuestionsExport.authSchema = {"type":"","header":""} as const;

/**
 * フォームにJSON形式の質問をインポートする
 * 
 */
export const formQuestionsImport = ({formId}: {formId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/questions/import`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formQuestionsImport.method = "POST" as const;
formQuestionsImport.authSchema = {"type":"","header":""} as const;

/**
 * 回答を検索
 * 
 */
export const submissionSearch = ({formId}: {formId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/submissions/search`;
    return __queries ? `${__path}?${__queries}` : __path;
};
submissionSearch.method = "POST" as const;
submissionSearch.authSchema = {"type":"","header":""} as const;

/**
 * 回答の再送
 * 
 */
export const submissionResubmitToWebhook = ({formId, submissionId}: {formId: string, submissionId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/submissions/${submissionId}/resubmit`;
    return __queries ? `${__path}?${__queries}` : __path;
};
submissionResubmitToWebhook.method = "POST" as const;
submissionResubmitToWebhook.authSchema = {"type":"","header":""} as const;

/**
 * 回答を作成
 * 
 */
export const submissionCreate = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/submissions`;
    return __queries ? `${__path}?${__queries}` : __path;
};
submissionCreate.method = "POST" as const;
submissionCreate.authSchema = {"type":"","header":""} as const;

/**
 * ゲストがフォームの情報を取得する
 * 
 */
export const guestFormGet = ({formId}: {formId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/guest/forms/${formId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
guestFormGet.method = "GET" as const;
guestFormGet.authSchema = {"type":"","header":""} as const;

/**
 * Googleのトークンでサインインする
 * 
 */
export const signInWithGoogle = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/auth/signInWithGoogle`;
    return __queries ? `${__path}?${__queries}` : __path;
};
signInWithGoogle.method = "POST" as const;
signInWithGoogle.authSchema = {"type":"","header":""} as const;

/**
 * Googleのトークンでサインアップする
 * 
 */
export const signUpWithGoogle = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/auth/signUpWithGoogle`;
    return __queries ? `${__path}?${__queries}` : __path;
};
signUpWithGoogle.method = "POST" as const;
signUpWithGoogle.authSchema = {"type":"","header":""} as const;

/**
 * フォームにWebhookを追加する
 * 
 */
export const formWebhookAppend = ({formId, appId}: {formId: string, appId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/apps/${appId}/webhooks`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formWebhookAppend.method = "POST" as const;
formWebhookAppend.authSchema = {"type":"","header":""} as const;

/**
 * フォームに紐づいたWebhookを削除する
 * 
 */
export const formWebhookDelete = ({formId, appId, webhookId}: {formId: string, appId: string, webhookId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/apps/${appId}/webhooks/${webhookId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formWebhookDelete.method = "DELETE" as const;
formWebhookDelete.authSchema = {"type":"","header":""} as const;

/**
 * フォームに紐づいたWebhookを更新する
 * 
 */
export const formWebhookUpdate = ({formId, appId, webhookId}: {formId: string, appId: string, webhookId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/apps/${appId}/webhooks/${webhookId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formWebhookUpdate.method = "PATCH" as const;
formWebhookUpdate.authSchema = {"type":"","header":""} as const;

/**
 * フォームに紐づいたWebhookを全件取得する
 * 
 */
export const formWebhookFindAll = ({formId, appId}: {formId: string, appId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/apps/${appId}/webhooks`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formWebhookFindAll.method = "GET" as const;
formWebhookFindAll.authSchema = {"type":"","header":""} as const;

/**
 * フォームAppに紐づいたSignatureKeyを生成する
 * 
 */
export const formAppSignatureKeyGenerate = ({formId, appId}: {formId: string, appId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/apps/${appId}/signature_key`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formAppSignatureKeyGenerate.method = "POST" as const;
formAppSignatureKeyGenerate.authSchema = {"type":"","header":""} as const;

/**
 * フォームに紐づいたAppをFormIDから全件取得する
 * 
 */
export const formAppFindAll = ({formId}: {formId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/apps`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formAppFindAll.method = "GET" as const;
formAppFindAll.authSchema = {"type":"","header":""} as const;

/**
 * フォームに紐づいたAppをAppIDから取得する
 * 
 */
export const formAppGet = ({formId, appId}: {formId: string, appId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/apps/${appId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formAppGet.method = "GET" as const;
formAppGet.authSchema = {"type":"","header":""} as const;

/**
 * フォームにAppを追加する
 * 
 */
export const formAppAppend = ({formId}: {formId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/apps`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formAppAppend.method = "POST" as const;
formAppAppend.authSchema = {"type":"","header":""} as const;

/**
 * フォームに紐づいたAppを削除する
 * 
 */
export const formAppDelete = ({formId, appId}: {formId: string, appId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/apps/${appId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formAppDelete.method = "DELETE" as const;
formAppDelete.authSchema = {"type":"","header":""} as const;

/**
 * フォームに紐づいたAppを更新する
 * 
 */
export const formAppUpdate = ({formId, appId}: {formId: string, appId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/apps/${appId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formAppUpdate.method = "PATCH" as const;
formAppUpdate.authSchema = {"type":"","header":""} as const;

/**
 * フォームに紐づいた権限を全件取得する。管理者以上のフォーム権限が必要。
 * 
 */
export const formPermissionFindAllByFormId = ({formId}: {formId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/permissions`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formPermissionFindAllByFormId.method = "GET" as const;
formPermissionFindAllByFormId.authSchema = {"type":"","header":""} as const;

/**
 * ユーザーに紐づいたフォームの権限を追加する。管理者以上のフォーム権限が必要。
 * 
 */
export const formPermissionCreate = ({formId}: {formId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/permissions`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formPermissionCreate.method = "POST" as const;
formPermissionCreate.authSchema = {"type":"","header":""} as const;

/**
 * ユーザーに紐づいたフォームの権限を更新する。管理者以上のフォーム権限が必要。
 * 
 */
export const formPermissionUpdate = ({formId, id}: {formId: string, id: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/permissions/${id}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formPermissionUpdate.method = "PATCH" as const;
formPermissionUpdate.authSchema = {"type":"","header":""} as const;
export const matsuriForms_v1 = {healthCheck,formGet,formGetByRevision,formCreate,formFindAll,formUpdate,sharedFormFindAll,formActivateSheetFeature,formGetConnectedSheet,formPublishStatusChangeToPrivate,formsCreateNewRevision,formUpdateQuestionsOrder,formPublish,formReplaceOwner,formForceReplaceOwner,formQuestionCreate,formQuestionInsert,formQuestionDelete,formQuestionUpdate,formQuestionsExport,formQuestionsImport,submissionSearch,submissionResubmitToWebhook,submissionCreate,guestFormGet,signInWithGoogle,signUpWithGoogle,formWebhookAppend,formWebhookDelete,formWebhookUpdate,formWebhookFindAll,formAppSignatureKeyGenerate,formAppFindAll,formAppGet,formAppAppend,formAppDelete,formAppUpdate,formPermissionFindAllByFormId,formPermissionCreate,formPermissionUpdate};
